// extracted by mini-css-extract-plugin
module.exports = {"sFormSearch":"sFormSearch_sFormSearch__AP4lK","spinner":"sFormSearch_spinner__izns6"};